/*
  AAA dropdown: turns <select data-aaa-dropdown> into a small custom dropdown that always opens directly under
  (or, near the bottom of the screen, above) its control, instead of the phone's own picker (a centred dialog on
  Android, a wheel on iPhone). Used by the buy box frequency select and the cart drawer frequency selects.

  The native select stays in the page (hidden) as the source of truth: picking an option sets select.value and
  fires "change", so the existing handlers keep working. If code changes select.value itself, it can fire an
  "aaa-dd-sync" event on the select to refresh the label. Loaded once from layout/theme.liquid; selects added
  later (the cart drawer is re-rendered by AJAX) are picked up by a MutationObserver.
*/
(function () {
  if (window.__aaaDropdown) return;
  window.__aaaDropdown = true;

  var CSS = [
    '.aaa-dd{position:relative;display:inline-flex;vertical-align:baseline;max-width:100%;}',
    '.aaa-dd>select{display:none !important;}',
    '.aaa-dd__btn{display:inline-flex;align-items:center;gap:4px;margin:0;padding:0;border:0;background:none;font:inherit;line-height:inherit;color:#083150;font-weight:700;cursor:pointer;white-space:nowrap;text-align:left;-webkit-tap-highlight-color:transparent;}',
    '.aaa-dd__btn svg{flex:none;width:10px;height:10px;fill:none !important;stroke:currentColor;stroke-width:1.8;stroke-linecap:round;stroke-linejoin:round;transition:transform .15s;}',
    '.aaa-dd.is-open .aaa-dd__btn svg{transform:rotate(180deg);}',
    '.aaa-dd__btn:focus-visible{outline:2px solid #083150;outline-offset:2px;border-radius:2px;}',
    '.aaa-dd__list{position:fixed;z-index:2147483002;top:0;left:0;min-width:170px;max-height:260px;overflow-y:auto;overscroll-behavior:contain;margin:0;padding:4px;list-style:none;background:#fff;border:1px solid #E6E8EB;border-radius:10px;box-shadow:0 12px 32px rgba(8,49,80,.16);}',
    '.aaa-dd__list[hidden]{display:none;}',
    '.aaa-dd__opt{display:flex;align-items:center;justify-content:space-between;gap:12px;width:100%;min-height:40px;padding:8px 10px;border:0;border-radius:7px;background:none;font:inherit;font-size:14px;font-weight:500;line-height:1.3;color:#1F2933;text-align:left;cursor:pointer;white-space:nowrap;}',
    '.aaa-dd__opt:hover,.aaa-dd__opt:focus-visible{background:#F3F6F9;outline:none;}',
    '.aaa-dd__opt[aria-selected="true"]{font-weight:700;color:#083150;}',
    '.aaa-dd__opt svg{flex:none;width:14px;height:14px;fill:none !important;stroke:#1D8220;stroke-width:2.2;stroke-linecap:round;stroke-linejoin:round;visibility:hidden;}',
    '.aaa-dd__opt[aria-selected="true"] svg{visibility:visible;}'
  ].join('');
  var style = document.createElement('style');
  style.textContent = CSS;
  document.head.appendChild(style);

  var CHEVRON = '<svg viewBox="0 0 10 6" aria-hidden="true"><path d="M1 1l4 4 4-4"/></svg>';
  var CHECK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';
  var uid = 0;
  var openDd = null;

  function label(sel) {
    var o = sel.options[sel.selectedIndex];
    return o ? o.text : '';
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]; }); }

  function sync(dd) {
    dd.__btnText.textContent = label(dd.__sel);
  }

  function close(dd, focusBtn) {
    if (!dd) return;
    dd.classList.remove('is-open');
    dd.__list.hidden = true;
    dd.__btn.setAttribute('aria-expanded', 'false');
    if (openDd === dd) openDd = null;
    if (focusBtn) dd.__btn.focus();
  }

  function open(dd) {
    var sel = dd.__sel;
    if (sel.disabled) return;
    if (openDd && openDd !== dd) close(openDd);
    dd.__list.innerHTML = Array.prototype.map.call(sel.options, function (o, i) {
      var on = i === sel.selectedIndex;
      return '<li role="presentation"><button type="button" class="aaa-dd__opt" role="option" aria-selected="' + on + '" data-i="' + i + '"' + (o.disabled ? ' disabled' : '') + '>' +
        '<span>' + esc(o.text) + '</span>' + CHECK + '</button></li>';
    }).join('');
    dd.__list.hidden = false;
    dd.classList.add('is-open');
    dd.__btn.setAttribute('aria-expanded', 'true');
    openDd = dd;
    place(dd);
    var cur = dd.__list.querySelector('[aria-selected="true"]') || dd.__list.querySelector('.aaa-dd__opt');
    if (cur) cur.focus({ preventScroll: true });
  }

  /* The list is position: fixed so boxes with overflow: hidden (the subscribe box, the cart drawer) can't clip it.
     It sits 6px under the button, or above it when there isn't room below; it stays inside the screen sideways.
     A transformed ancestor (the cart drawer's slide-in) becomes the reference for fixed positioning, so offset by it. */
  function place(dd) {
    var list = dd.__list;
    var r = dd.__btn.getBoundingClientRect();
    var h = list.offsetHeight, w = list.offsetWidth;
    var vw = document.documentElement.clientWidth, vh = window.innerHeight;
    var top = r.bottom + 6;
    if (top + h + 8 > vh && r.top - h - 6 > 8) top = r.top - h - 6;
    var left = Math.max(8, Math.min(r.left, vw - w - 8));
    var ox = 0, oy = 0;
    for (var a = dd.parentElement; a && a !== document.documentElement; a = a.parentElement) {
      var cs = getComputedStyle(a);
      if (cs.transform !== 'none' || cs.filter !== 'none' || cs.perspective !== 'none' || /transform|filter/.test(cs.willChange) || /paint|layout|strict|content/.test(cs.contain)) {
        var ar = a.getBoundingClientRect();
        ox = ar.left - a.scrollLeft; oy = ar.top - a.scrollTop;
        break;
      }
    }
    list.style.top = (top - oy) + 'px';
    list.style.left = (left - ox) + 'px';
  }

  function choose(dd, i) {
    var sel = dd.__sel;
    if (sel.selectedIndex !== i) {
      sel.selectedIndex = i;
      sync(dd);
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    }
    close(dd, true);
  }

  function enhance(sel) {
    if (sel.__aaaDd || !sel.parentNode) return;
    sel.__aaaDd = true;
    var id = 'aaa-dd-' + (++uid);
    var dd = document.createElement('span');
    dd.className = 'aaa-dd';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'aaa-dd__btn';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', id);
    if (sel.getAttribute('aria-label')) btn.setAttribute('aria-label', sel.getAttribute('aria-label') + ': ' + label(sel));
    btn.innerHTML = '<span></span>' + CHEVRON;
    var list = document.createElement('ul');
    list.className = 'aaa-dd__list';
    list.id = id;
    list.setAttribute('role', 'listbox');
    list.hidden = true;
    sel.parentNode.insertBefore(dd, sel);
    dd.appendChild(sel);
    dd.appendChild(btn);
    dd.appendChild(list);
    dd.__sel = sel; dd.__btn = btn; dd.__list = list; dd.__btnText = btn.firstChild;
    sync(dd);

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (dd.classList.contains('is-open')) close(dd); else open(dd);
    });
    btn.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); open(dd); }
    });
    list.addEventListener('click', function (e) {
      var o = e.target.closest('.aaa-dd__opt');
      if (!o || o.disabled) return;
      e.preventDefault();
      e.stopPropagation();
      choose(dd, Number(o.getAttribute('data-i')));
    });
    list.addEventListener('keydown', function (e) {
      var opts = Array.prototype.slice.call(list.querySelectorAll('.aaa-dd__opt:not([disabled])'));
      var i = opts.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') { e.preventDefault(); (opts[i + 1] || opts[0]).focus(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); (opts[i - 1] || opts[opts.length - 1]).focus(); }
      else if (e.key === 'Escape') { e.preventDefault(); close(dd, true); }
      else if (e.key === 'Tab') { close(dd); }
    });
    sel.addEventListener('change', function () { sync(dd); });
    sel.addEventListener('aaa-dd-sync', function () { sync(dd); });
    /* Options can be rebuilt or reordered after enhancing (buy box plans, cart sort). */
    new MutationObserver(function () { sync(dd); }).observe(sel, { childList: true, subtree: true, attributes: true });
  }

  document.addEventListener('click', function (e) {
    if (openDd && !openDd.contains(e.target)) close(openDd);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openDd) close(openDd, true);
  });
  /* Close on a real width change (rotation, window resize), not the height changes phones make when the address
     bar shows or hides. */
  var lastW = window.innerWidth;
  window.addEventListener('resize', function () {
    if (window.innerWidth !== lastW && openDd) close(openDd);
    lastW = window.innerWidth;
  });
  /* Scrolling the page (or the cart drawer) would leave the fixed list behind, so close it; scrolling the list
     itself is fine. */
  document.addEventListener('scroll', function (e) {
    if (openDd && !(e.target && e.target.nodeType === 1 && openDd.__list.contains(e.target))) close(openDd);
  }, true);

  function scan() {
    document.querySelectorAll('select[data-aaa-dropdown]').forEach(enhance);
  }
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
})();
